module.exports = __webpack_public_path__ + "static/nina_portrait-92588bd996c79eb1843acb1f3b917a31.jpg";